import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Cookies from 'js-cookie';
import translationEN from './locales/en.json';
import translationES from './locales/es.json';


const language = Cookies.get('i18next') || 'english';

i18n.use(initReactI18next).init({
    debug: true,
    lng: language,
    fallbackLng: 'english', 

    resources: {
        english: {
            translation: translationEN
        },
        spanish: {
            translation: translationES
        }
    }
});

export default i18n;
